/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../../assets/Icons/index.js";
import Loader from "../../../../../components/Loader/Index.jsx";
import ScheduleInternalTransactionDetailPopup from "../../../../../components/Transactions/ScheduleInternalTransaction/ScheduleInternalTransactionDetailPopup/index.jsx";
import ScheduleInternalTransactionMultiApprovalDetailsCard from "../../../../../components/Transactions/ScheduleInternalTransaction/ScheduleInternalTransactionMultiApprovalDetailsCard/index.jsx";
import CommonToast from "../../../../../components/_utils/CommonToast/index.jsx";
import ApprovalTopNavComponent from "../../../../../components/_utils/CommonTopNav/ApprovalTopNav/index.jsx";
import InternalScheduleTxnDeclinePopup from "../../../../../components/_utils/TransactionCommonComponents/CommonDeclinePopups/InternalScheduleTxnDeclinePopup.jsx";
import UniversalRefreshToast from "../../../../../components/_utils/UniversalRefreshToast/index.jsx";
import {
  scheduledInternalApprove,
  scheduledInternalReject,
} from "../../../../../redux/features/transactions/scheduleInternalTransactions/index.js";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider.js";

const ScheduleInternalMultiApproval = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // States
  const [actionLoading, setActionLoading] = useState(false);
  const [selectedCardIds, setSelectedCardIds] = useState([]);
  const [showRejectPopup, setShowRejectPopup] = useState(false);
  const [internalScheduleId, setInternalScheduleId] = useState("");
  const [isAdditionalPopupOpen, setIsAdditionalPopupOpen] = useState("");
  const [selectedSendTransactions, setSelectedSendTransactions] = useState([]);

  // Selector
  const services = useSelector((state) => state.refreshToken.services);

  // Effects
  useEffect(() => {
    // Initialize state from session storage
    const sessionData =
      JSON.parse(sessionStorage.getItem("intSelectedScheduleCard")) || [];
    if (sessionData.length > 0) {
      setSelectedSendTransactions(sessionData[0].selectedDetails || []);
      setSelectedCardIds(sessionData[0].selectedIds || []);
    }

    return () => {};
  }, [dispatch]);

  useEffect(() => {
    if (
      selectedSendTransactions?.length === 0 &&
      selectedCardIds.length === 0
    ) {
      // Only navigate if we've initialized and found empty, or user unselected all?
      // Ideally check if session *allows* empty, but usually if coming here, we expect data.
      // If state is empty initially, this might trigger before useEffect above runs?
      // No, useEffect runs after render. Initialize state empty usually triggers this?
      // Better to check session directly or use a 'loaded' flag, but adhering to existing logic pattern:
      // Existing logic: if (formatedData?.length === 0) navigate(...)
    }
    const sessionData =
      JSON.parse(sessionStorage.getItem("intSelectedScheduleCard")) || [];
    if (sessionData.length === 0) {
      navigate("/internal_transaction_dashboard/schedule_multi_approval");
    }
  }, [navigate]);

  // Sync state back to session storage
  useEffect(() => {
    if (selectedSendTransactions.length > 0 || selectedCardIds.length > 0) {
      sessionStorage.setItem(
        "intSelectedScheduleCard",
        JSON.stringify([
          {
            selectedDetails: selectedSendTransactions,
            selectedIds: selectedCardIds,
          },
        ]),
      );
    }
  }, [selectedSendTransactions, selectedCardIds]);

  // Handlers
  const closeScheduleInternalTxnModal = () => {
    setIsAdditionalPopupOpen("");
  };

  const handleTxnAction = async (id, reason = "", type) => {
    const isReject = type === "reject";
    const toastMsg = isReject ? "Rejecting schedule" : "Approving schedule";
    const reduxAction = isReject
      ? scheduledInternalReject
      : scheduledInternalApprove;

    setActionLoading(true);
    UniversalRefreshToast(toastMsg);

    const data = await dispatch(
      reduxAction({
        id,
        reason,
        services,
        navigate,
        type: "multiReject",
      }),
    );

    const payload = data?.payload;

    setTimeout(() => {
      setActionLoading(false);
      toast.dismiss();

      if (payload?.status === 500) {
        setTimeout(() =>
          CommonToast({
            text: payload?.error,
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          }),
        );
      }

      if (payload?.errors?.user_unauthorized?.[0]) {
        setTimeout(() => {
          navigate("/feature_not_assigned", {
            state: { unavailableService: "IAScheduledTxn" },
          });
        }, 1000);
        return;
      }

      if (payload?.status === false) {
        navigate(
          "/internal_transaction_dashboard/schedule_multi_approval/schedules_multi_approval/schedules_multi_transaction_error",
          { state: type },
        );
      } else if (payload?.status === true) {
        const selectedscheduleData = {
          selectedSendTransactions: payload?.transactions,
          selectedTransactions: selectedCardIds,
        };

        sessionStorage.setItem(
          "selectedscheduleData",
          JSON.stringify(selectedscheduleData),
        );
        if (type === "reject") {
          navigate(
            "/internal_transaction_dashboard/schedule_multi_approval/schedules_multi_approval/schedules_multi_transaction_reject",
          );
        } else {
          navigate(
            "/internal_transaction_dashboard/schedule_multi_approval/schedules_multi_approval/schedules_multi_transaction_success",
          );
        }
      }
      if (isReject) setShowRejectPopup(false);
    }, 2000);
  };

  return (
    <>
      {/* Popups */}
      {showRejectPopup && (
        <InternalScheduleTxnDeclinePopup
          allTxnData={selectedSendTransactions}
          handleClose={() => setShowRejectPopup(false)}
          txnId={selectedCardIds}
          updateAllTxn={() => {}}
          flow="multiApproval"
          toastType="multiSchedule"
        />
      )}

      {isAdditionalPopupOpen !== "" && internalScheduleId !== "" ? (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <ScheduleInternalTransactionDetailPopup
            closeScheduleInternalTxnModal={closeScheduleInternalTxnModal}
            schedule_internaltxn_id={internalScheduleId}
            detailSelected={isAdditionalPopupOpen}
            typeMulti="MultiApproval"
            type={"bene_account_detail_modal"}
          />
        </div>
      ) : null}

      <div
        className={`flex flex-col h-full justify-start bg-primary-bg ${
          showRejectPopup ? "reject-popup-open" : ""
        }`}
      >
        {/* Loading Overlay */}
        {actionLoading ? (
          <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
            <div className="flex justify-center items-center">
              <Loader />
            </div>
          </div>
        ) : null}

        <div className="hidden Qmd:block min-h-[var(--navbar-breadcrumb-height)] h-navbar-breadcrumb-height bg-primary-nav"></div>

        <div className="h-full overflow-y-scroll relative bottom-bottom-base mb-padding-base ">
          <ApprovalTopNavComponent
            topNavCtaBtn1Props={{
              btnText: "Previous",
              btnType: "button",
              enabledBgColor: "var(--primary-nav-act)",
              handleFunction: () => navigate(-1),
              enabledTextColor: "var(--text-primary)",
              isDisabled: false,
              hoverOption: "white",
            }}
            topNavCtaBtn2Needed={false}
            topNavCtaBtnWithIcon1Props={{
              btnText: "Reject schedules",
              handleFunction: () => {
                if (
                  selectedCardIds?.length ===
                  GlobalConfiguration.lengthCheckZero
                ) {
                  return;
                } else {
                  setShowRejectPopup(true);
                }
              },
              enabledBgColor: "var(--negative-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS?.REJECT_ICON_RED_WITH_WHITE_CIRCLE,
              isDisabled:
                selectedCardIds?.length === GlobalConfiguration.lengthCheckZero,
              iconToBeAlign: "right",
            }}
            topNavCtaBtnWithIcon2Props={{
              btnText: "Approve schedules",
              handleFunction: () => {
                if (
                  selectedCardIds?.length ===
                  GlobalConfiguration.lengthCheckZero
                ) {
                  return;
                } else {
                  handleTxnAction(selectedCardIds);
                }
              },
              enabledBgColor: "var(--positive-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS?.APPROVE_CIRCLE_GREEN_CHECKMARK,
              isDisabled:
                selectedCardIds?.length === GlobalConfiguration.lengthCheckZero,
              iconToBeAlign: "right",
            }}
            BottomHeader={`Schedule approval process`}
            BottomSubText={`Below are the schedules details. Approved schedules will generate transactions according to the specified frequency.`}
            isToggleNeeded={false}
            selectionBtnProps={{
              btnText: "View selected",
              btnType: "button",
              enabledBgColor: "var(--primary-nav-act)",
              handleFunction: () => {},
              enabledTextColor: "var(--text-primary)",
              isDisabled: false,
              icon: ICONS?.RELOAD_REFRESH_WHITE,
            }}
            iconComponentArray={[
              {
                enabledBgColor: "var(--primary-bg)",
                isLoading: actionLoading,
                handleFunction: () => {},
                isDisabled: false,
                icon: ICONS?.RELOAD_REFRESH_WHITE,
                title: "Refresh schedules",
                hoverOption: "white",
              },
            ]}
            assignLabelNeeded={false}
            assignTagNeeded={false}
          />
        </div>

        {/* Cards Grid */}
        <div className="h-full overflow-y-scroll relative Qmd:mb-margin-base mb-[var(--topnav-bottom-height)]">
          <h4 className="w-width-almost-full text-left text-font-md font-semibold text-text-primary mt-margin-md mx-auto whitespace-nowrap">
            Selected&nbsp;
            {selectedCardIds?.length === 1 ? "Transaction" : "Transactions"}
            &nbsp;({selectedCardIds?.length})
          </h4>
          <div className="standard-card-alignment gap-gap-md">
            {selectedSendTransactions?.map((data) => {
              return (
                <ScheduleInternalTransactionMultiApprovalDetailsCard
                  key={data.txn_id}
                  data={data}
                  selectedCardIds={selectedCardIds}
                  setSelectedCardIds={setSelectedCardIds}
                  selectedSendTransactions={selectedSendTransactions}
                  setSelectedSendTransactions={setSelectedSendTransactions}
                  setIsAdditionalPopupOpen={setIsAdditionalPopupOpen}
                  setInternalScheduleId={setInternalScheduleId}
                />
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default ScheduleInternalMultiApproval;
